import React from 'react';

import Notifications from '@appComponents/bb-notifications/main';

const NotificationsWrapper = () => (
	<aside>
		<Notifications />
	</aside>
);

export default NotificationsWrapper;
